<script>
export default {
    name: "BasePage",
    mounted() {
        this.$store.dispatch("setShowStartupLoader", false);
    }
};
</script>
